import { Card, Grid, Tab, Tabs } from '@mui/material'
import queryString from 'query-string'
import { useCallback, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { ContentWrapper } from '../../../../components/ContentWrapper'
import Helmet from '../../../../components/Helmet'
import HeaderContent from '../../../../components/Layouts/HeaderContent'
import PageUrls from '../../../../constants/page-urls'
import useAxios from '../../../../hooks/useAxios'
import { EOrderStatus, IOrder } from '../../../../types/order'
import OrderListTable from './components/OrderListTable'
import OrderReportCard from './components/OrderReportCard'
import ProductReportCard from './components/ProductReportCard'
import OrderFilter, { IFilterMapped } from './components/OrderFilter'
import { ITikTokAccount } from '../../../../types/tiktok'
import { useUser } from '../../../../hooks/useUser'
import { isAllowTikTok } from '../../../../constants/user'

const Menus: any[] = []

export enum LeadExcelStatus {
  Success = 'success',
  Warning = 'warning',
}

const titleMap = new Map<EOrderStatus | string, string>([
  ['', 'รายการคำสั่งซื้อ'],
  ['tiktok', 'รายการคำสั่งซื้อ Tiktok'],
])

const OrderTiktokListPage = () => {
  const navigate = useNavigate()
  const { merchant } = useUser()
  const platform = 'tiktok'
  const queryStr = queryString.parse(window.location.search)

  const [page, setPage] = useState<number>(1)
  const [cursorPrev, setCursorPrev] = useState<string>('')
  const [cursorHistory, setCursorHistory] = useState<string[]>([])
  const [activeTab, setActiveTab] = useState<number>(0)
  const [openId, setOpenId] = useState<string>('')
  const [visitedTabs, setVisitedTabs] = useState<Set<number>>(new Set([0]))

  const { data: tiktokAccounts, isLoading } = useAxios<ITikTokAccount[]>({
    method: 'GET',
    url: '/tiktok/merchant/accounts',
  })

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue)
    setVisitedTabs((prev) => {
      const newSet = new Set(prev)
      newSet.add(newValue)
      return newSet
    })
  }

  const query: any = {
    cursor: queryStr.cursor ?? '',
  }

  const [searchFilter, setSearchFilter] = useState<IFilterMapped>(query)
  const [filter, setFilter] = useState<IFilterMapped>(query)

  const [selectedOrders, setSelectedOrders] = useState<IOrder[]>([])

  const onFilterChange = useCallback(
    (newFilter: IFilterMapped) => {
      //console.log('newFilter', newFilter)
      setFilter(newFilter)
    },
    [filter],
  )

  const handlePageChange = (newFilter: IFilterMapped) => {
    setFilter(newFilter)
    setSearchFilter(newFilter)
    setPage(1)
    const newQuery = queryString.stringify(newFilter)
    navigate(`${PageUrls.Platforms.Tiktok}?${newQuery}`, {
      replace: true,
    })
  }

  const handleOnSearch = (newFilter: IFilterMapped) => {
    const filter = {
      ...newFilter,
      cursor: '',
    }
    setFilter(filter)
    setSearchFilter(filter)
    const newQuery = queryString.stringify(filter)
    navigate(`${PageUrls.Platforms.Tiktok}?${newQuery}`, {
      replace: true,
    })
  }
  const handleCursorChange = (cursor: string | undefined, isPrev: boolean) => {
    let newFilter = {
      ...filter,
      cursor,
    }

    if (cursor && cursor !== cursorPrev) {
      setCursorHistory((prev) => [...prev, cursorPrev])
    }

    if (isPrev) {
      if (cursorHistory.length > 0) {
        const prevCursor = cursorHistory[cursorHistory.length - 1]
        setCursorHistory((prev) => prev.slice(0, -1))
        setCursorPrev(prevCursor)
        newFilter.cursor = prevCursor
      }
      setPage(page - 1)
    } else {
      setCursorPrev(cursor || '')
      newFilter.cursor = cursor
      setPage(page + 1)
    }

    setFilter(newFilter)
    setSearchFilter(newFilter)

    const newQuery = queryString.stringify(newFilter)
    navigate(`${PageUrls.Platforms.Tiktok}?${newQuery}`, {
      replace: true,
    })
  }

  const params: any = {
    ...searchFilter,
    shopId: searchFilter.shopId ?? tiktokAccounts?.[0]?.shopId,
  }

  const ordersList = useAxios<{
    cursor: string
    orders: IOrder[]
  }>(
    visitedTabs.has(0)
      ? {
          method: 'GET',
          url: '/tiktok/orders',
          params,
        }
      : null,
  )

  if (!isAllowTikTok(merchant)) {
    navigate(PageUrls.Home)
    return <></>
  }

  return (
    <ContentWrapper>
      <Helmet title={titleMap.get(platform)} />
      <Grid container justifyContent="flex-start" alignItems="center">
        <Grid item>
          <HeaderContent
            goBack
            title={titleMap.get(platform) ?? ''}
            // routes={Menus.filter((menu) => menu.status === status)}
            descriptions={titleMap.get(platform) ?? ''}
          />
        </Grid>
      </Grid>

      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        sx={{ mb: 2 }}
        aria-label="order platform tabs"
      >
        <Tab label="รายการคำสั่งซื้อ" />
        <Tab label="รายงานร้านค้า" />
        <Tab label="รายงานสินค้า" />
      </Tabs>

      <div style={{ display: activeTab === 0 ? 'block' : 'none' }}>
        {visitedTabs.has(0) && (
          <Card
            sx={{
              padding: 2,
            }}
          >
            <OrderFilter
              tiktokAccounts={tiktokAccounts ?? []}
              filter={filter}
              onFilterChange={onFilterChange}
              onSearch={handleOnSearch}
            />
            <OrderListTable
              selectedData={selectedOrders}
              setSelectedData={setSelectedOrders}
              isLoading={ordersList.isLoading || isLoading}
              data={ordersList?.data?.orders ?? []}
              filter={filter}
              onFilterChange={onFilterChange}
              handlePageChange={handlePageChange}
              total={ordersList?.data?.orders?.length ?? 0}
              statusOrder={''}
              cursor={ordersList?.data?.cursor}
              cursorPrev={cursorPrev}
              onCursorChange={handleCursorChange}
              page={page}
            />
          </Card>
        )}
      </div>
      <div style={{ display: activeTab === 1 ? 'block' : 'none' }}>
        {visitedTabs.has(1) && (
          <OrderReportCard tiktokAccounts={tiktokAccounts ?? []} />
        )}
      </div>
      <div style={{ display: activeTab === 2 ? 'block' : 'none' }}>
        {visitedTabs.has(2) && (
          <ProductReportCard tiktokAccounts={tiktokAccounts ?? []} />
        )}
      </div>
    </ContentWrapper>
  )
}

export default OrderTiktokListPage
